import './bootstrap';
import { createRoot } from 'react-dom/client'
import Main from './Pages/main.jsx'

// Mount the React app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Main />);
